export default __webpack_public_path__ + "static/media/infinity.c3b166e2.png";